

function main(verbose) {

  function log(str){
    if (verbose) {
      console.log(str);
    }
  }

  function scrollTo(hash) {
    location.hash = "#" + hash;
  }

  function observableEmbedResize() {
    // Select the embed iframe.
    const iframe = document.querySelector(".observable");

    // The Embedly protocol is to send the height as part of a stringified object.
    // In this example, the resize message is the only message being sent; however,
    // the checks are good practice, lest we try to interpret unrelated messages as
    // resize events. https://docs.embed.ly/v1.0/docs/provider-height-resizing
    function onMessage(message) {
      if (message.source !== iframe.contentWindow) return;
      let {data} = message;

      // If message isn’t valid JSON, it must not be our resize event.
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (ignore) {
          return;
        }
      }

      // Make sure it’s the resize event.
      if (data.context !== "iframe.resize") return;

      // Set the iframe’s height!
      iframe.style.height = `${data.height}px`;
    }

    // Attach our listener for the message from the iframe
    addEventListener("message", onMessage);
  }

  function getCookie(cname) {
    log(`getting cookie ${cname}`);
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    log(`cookie string = ${ca}`);
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        var v = c.substring(name.length, c.length);
        log(`value: ${v}`);
        v = parseInt(v);
        if (Number.isInteger(v)) {
          return v;
        } else {
          log("cookie is not a Number, returning 0");
          return 0;
        }
      }
    }
    log('not found! returning 0');
    return 0;
  }

  function setCookie(n, v) {
    log(`setting cookie ${n} to ${v}`);
    document.cookie = n + "=" + v + ";path=/";
  }

  function latestArticleTimeStamp() {
    const latestUpdate = parseInt(document.querySelector("#updates").dataset.last);
    log("latestUpdate "+latestUpdate);
    return latestUpdate;
  }

  function lastClickUpdatesTimestamp() {
    const v = parseInt(getCookie("last"));
    log(`lastClickUpdatesTimestamp ${v}`);
    return v;
  }

  function now() {
    const v = parseInt(Date.now()*0.001);
    log(`now = ${v}`);
    return v;
  }

  function setNewArticleNotification() {
    log("setNewArticleNotification to visible...");
    document.querySelector("#notify-update").style.display = "inline";
  }

  function clearNewArticleNotification() {
    log("setNewArticleNotification to hidden...");
    document.querySelector("#notify-update").style.display = "none";
  }

  function handleUpdateClick() {
    log("handleUpdateClick called");
    setCookie("last", now());
    refreshLatestUpdateNotification();
  }

  function refreshLatestUpdateNotification() {
    log("refreshLatestUpdateNotification: checking last visit...");
    if ( lastClickUpdatesTimestamp() < latestArticleTimeStamp() ) {
      log("last visit BEFORE latest article update...");
      setNewArticleNotification();
    } else {
      log("last visit AFTER latest article update...");
      clearNewArticleNotification();
    }
  }

  function addUpdateClickListener() {
    log("addUpdateClickListener");
    const e = document.querySelector("#menu-updates");
    e.addEventListener("click", handleUpdateClick);
  }

  const startup = function() {
    addUpdateClickListener();
    refreshLatestUpdateNotification();
    observableEmbedResize();
  }

  log("app instantiated");
  return startup;
};

app = main(false);
window.addEventListener("DOMContentLoaded", app());

